"use strict";

export default {
  namespaced: true,
  state() {
    return {
      currentProcess: { id: "default", name: "process.define.default" },
      specialProcesses: [
        { id: "sibur-test", name: "process.define.siburTest" },
        { id: "default", name: "process.define.default" }
      ]
    };
  },
  mutations: {
    setCurrentProcess(state, process) {
      state.currentProcess = process;
    }
  },
  getters: {
    currentProcess: state => state.currentProcess,
    specialProcesses: state => state.specialProcesses
  }
};
